import {
    apiRegister
} from '../../common/api';

import {
    isPlain,
    isNumber,
    isArray,
    array2map,
    text2time
} from '../../common/utils';
import { ERR_REQ_CID, ERR_REP_CONFIG } from '../../common/const';

/*
协议Id 
877
项目 
模块 
方式 
https 
命令（路径） 
/award/match/config/
说明
获取斗K比赛配置详情
*/

const config = apiRegister('config', {
    protoId: 877,
    path: '/award/match/config/',
    cache: 600,  // 默认缓存600秒
    checkQuery(Q) {
        if (!isNumber(Q.cId)) {
            return ERR_REQ_CID // 参数错误
        }
        return 0
    },
    checkResult(R) {
        const {
            configInfo,
            blockList,
            cupList
        } = R
        if (!isPlain(configInfo) || !isArray(blockList) || !isArray(cupList)) {
            return ERR_REP_CONFIG // 数据格式非法
        }
        return 0
    },
    formatResult(R) {
        const {
            blockList,
            configInfo,
            cupList
        } = R
        const blockMap = array2map(blockList, 'name')
        const cupMap = array2map(cupList, 'cupId')

        // 时间转化
        const {
            signBeginTime,
            signEndTime,
            preBeginTime,
            preEndTime,
            preResTime,
            finalBeginTime,
            finalEndTime,
            finalResTime,
            awardTime,
            addressEndTime
        } = configInfo

        return {
            blockList,
            configInfo,
            cupList,
            blockMap,
            cupMap,
            timeMap: {
                signBegin: text2time(signBeginTime),
                signEnd: text2time(signEndTime),
                preBegin: text2time(preBeginTime),
                preEnd: text2time(preEndTime),
                preRes: text2time(preResTime),
                finalBegin: text2time(finalBeginTime),
                finalEnd: text2time(finalEndTime),
                finalRes: text2time(finalResTime),
                awardTime: text2time(awardTime),
                addressEnd: text2time(addressEndTime)
            }
        }
    }
})

export const configLoad = config.send
